import React, {FunctionComponent} from 'react';

const NoNotificationBrick: FunctionComponent = () =>
  (
    <div
      className="bg-gray-light rounded-md text-center py-14 px-24 bg-gradient-to-r from-gray-light to-yellow-light">
      <span className="text-gray-dark text-base italic">
        So far, everything is fine and no tips for you
      </span>
    </div>
  );

export default NoNotificationBrick;
